import { useState } from 'react';
import { Alert } from '@mui/material';
import { Button } from 'react-admin';
import EmailIcon from '@mui/icons-material/Email';
import { useRecordContext, useNotify } from 'react-admin';
import { DEFAULT_API_ADMIN } from '../../constants';
import { httpClientReactAdmin } from '../../lib';

export const EmailVerificationInfoAlert = () => (
  <Alert severity="info" sx={{ mt: 2 }}>
    Após o cadastro, um email de verificação será enviado para o endereço informado. O login só ficará disponível após a confirmação do email.
  </Alert>
);

interface EmailVerificationWarningProps {
  source?: string;
}

const resolveField = (record: any, path: string): boolean => {
  return path.split('.').reduce((obj, key) => obj?.[key], record);
};

export const EmailVerificationWarning = ({ source = 'emailVerified' }: EmailVerificationWarningProps) => {
  const record = useRecordContext();
  if (!record || resolveField(record, source)) return null;
  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      O email deste usuário ainda não foi verificado. O login está desativado até a confirmação.
    </Alert>
  );
};

const useResendEmail = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!record) return;
    setLoading(true);
    try {
      await httpClientReactAdmin(
        `${DEFAULT_API_ADMIN}/employees/${record.id}/resend-verification-email`,
        { method: 'POST', body: JSON.stringify({}) },
      );
      notify('Email de verificação reenviado!', { type: 'success' });
    } catch (err: any) {
      const message = err?.body?.message || err?.message || 'Erro ao reenviar email';
      notify(message, { type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return { loading, handleClick };
};

export const ResendEmailButton = ({ size = 'small' }: { size?: 'small' | 'medium' | 'large', [k: string]: any }) => {
  const record = useRecordContext();
  const { loading, handleClick } = useResendEmail();

  if (!record || record.emailVerified) return null;

  return (
    <Button
      label="Reenviar Email"
      onClick={handleClick}
      disabled={loading}
      startIcon={<EmailIcon />}
      variant="outlined"
      size={size}
      sx={{ ml: 2 }}
    />
  );
};
